import { styled } from "common/components";

export const StyledLoginForm = styled("form")<{ compactGap?: boolean }>(
  ({ theme, compactGap }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
    rowGap: theme.spacing(compactGap ? theme.spacing(0.5) : theme.spacing(1.5)),
  })
);
